import { Controller } from "@hotwired/stimulus"

// Controls timeframe filtering for stats displays
// Connects to data-controller="stats-timeframe"
export default class extends Controller {
  static targets = ["button", "label", "dropdown"]
  static values = {
    url: String,
    current: { type: String, default: "7d" },
    frameId: String
  }

  connect() {
    this.updateActiveButton()
  }

  select(event) {
    event.preventDefault()
    const timeframe = event.currentTarget.dataset.timeframe
    this.currentValue = timeframe
    this.updateActiveButton()
    this.updateLabel(event.currentTarget.dataset.label)
    this.closeDropdown()
    this.refreshFrame()
  }

  updateActiveButton() {
    this.buttonTargets.forEach(button => {
      const isActive = button.dataset.timeframe === this.currentValue
      if (isActive) {
        button.classList.add("bg-gray-100", "dark:bg-neutral-700")
      } else {
        button.classList.remove("bg-gray-100", "dark:bg-neutral-700")
      }
    })
  }

  updateLabel(label) {
    if (this.hasLabelTarget) {
      this.labelTarget.textContent = label
    }
  }

  closeDropdown() {
    // Close the hs-dropdown by removing the open class
    const dropdown = this.element.querySelector('.hs-dropdown')
    if (dropdown) {
      // Use HSDropdown API if available
      if (window.HSDropdown) {
        const instance = window.HSDropdown.getInstance(dropdown)
        if (instance) {
          instance.close()
          return
        }
      }
      // Fallback: click the toggle button to close
      const toggle = dropdown.querySelector('[aria-expanded="true"]')
      if (toggle) {
        toggle.click()
      }
    }
  }

  refreshFrame() {
    // Find the frame by ID (it's a sibling element, not inside the controller)
    const frameId = this.frameIdValue
    if (!frameId) return

    const frame = document.getElementById(frameId)
    if (frame) {
      const url = new URL(this.urlValue, window.location.origin)
      url.searchParams.set("timeframe", this.currentValue)
      frame.src = url.toString()
    }
  }
}
